/**
 * RTWO Runtime — Cached connected peer count for sync readiness surfaces.
 */

let cachedConnectedPeerCount = 0;

export function publishConnectedPeerCountForRuntime(count: number): void {
  cachedConnectedPeerCount = Number.isFinite(count) && count >= 0 ? count : 0;
}

export function getCachedConnectedPeerCount(): number {
  return cachedConnectedPeerCount;
}

export function resetConnectedPeerCountCacheForTests(): void {
  cachedConnectedPeerCount = 0;
}
